import { parseAsString, useQueryStates } from 'nuqs';

export type DocumentDetailsQueryParams = {
  documentId?: string;
};

const defaultQueryParams = {
  documentId: '',
};

const useDocumentsQueryParams = () => {
  const [queryParams, setQueryParams] = useQueryStates(
    {
      document_id: parseAsString.withDefault(defaultQueryParams.documentId),
    },
    { history: 'push', clearOnDefault: true, shallow: false },
  );

  const clear = () => {
    setQueryParams({
      document_id: defaultQueryParams.documentId,
    });
  };

  const push = (documentId: string) => {
    setQueryParams({
      document_id: documentId ?? defaultQueryParams.documentId,
    });
  };

  const values: DocumentDetailsQueryParams = {
    documentId: queryParams.document_id.length > 0 ? queryParams.document_id : undefined,
  };

  return {
    values,
    clear,
    push,
  };
};

export default useDocumentsQueryParams;
